import React, { useEffect, useState } from 'react';
import { withRouter } from "react-router-dom";
import { store } from 'react-notifications-component';

import api from '../../services/api';
import identifyErrorMenssage from '../../services/identifyErrorMenssage';

import Modal from "../../components/modal/modalGeneric";
import InputV3 from '../../components/input/novo/input_v3';

import SetaCinza from '../../assets/icons/icon-right-gray.svg';
import SetaBranca from '../../assets/icons/icon-right-white.svg';
import LogoBranca from '../../assets/logo-agroreceita-branco.svg';
import SegurityPassword from '../../assets/undraw_segurity_password.png';

import * as S from './password-styles';
import { theme } from '../../styles/theme';
import { BodyG, H3, H6, TaglineM } from '../../styles/stylesTypography';
import Button from '../../components/button/button_v2';

const Novasenha = () => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const [erroSenha, setErroSenha] = useState(false);
    const [erroSenhaMsg, setErroSenhaMsg] = useState('');

    const [loading, setLoading] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);

    const [validacaoAtivada, setValidacaoAtivada] = useState(false);

    const [showModalRedirect, setShowModalRedirect] = useState(false)

    const getTicket =  window.location.pathname.split('/senha/')[1];

    const [isValidTicket, setIsValidticket] = useState(false)

    const validaTicket = async () => {
        setLoading(true)
        
        try {
            const response = await api.post('/valida/ticket', {ticket: getTicket})

            if(response) {
                setIsValidticket(true)
            }
        } catch (error) {
            setIsValidticket(false)

            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error, "ERRO-676 Ocorreu um erro ao validar o ticket - Tente novamente, se o erro persistir acione o suporte."),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        validaTicket();
    },[]);

    useEffect(() => {
        setIsButtonDisabled(!(password && confirmPassword && isValidTicket === true));
    }, [password, confirmPassword, isValidTicket]);

    const isPasswordValid = () => {
        if (password !== confirmPassword) {
            setErroSenha(true);
            setErroSenhaMsg('As senhas não coincidem.');
    
            store.addNotification({
                title: "Erro!",
                message: "As senhas precisam ser iguais.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
            return false;
        }
        return true;
    };

    const handleContinuarClick = async () => {
        setValidacaoAtivada(true);

        setLoading(true);
        setErroSenha(false);
        setErroSenhaMsg('');

        if (isPasswordValid()) {
            const payload = {
                password: password,
                ticket: getTicket
            };

            try {
                const response = await api.post(`/senha`, payload);

                setShowModalRedirect(true)

                store.addNotification({
                    title: response.data.data,
                    message: response.data.message,
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            } catch (error) {
                store.addNotification({
                    title: "Erro!",
                    message: identifyErrorMenssage(error, "ERRO-677 Ocorreu um erro ao criar senha - Tente novamente, se o erro persistir acione o suporte."),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            } finally {
                setLoading(false);
            }
        } else {
            setLoading(false);
        }
    };

    const pressKey = (e) => {
        if (e.code === 'Enter') {
            if (password && confirmPassword) {
                handleContinuarClick();
            }
        }
    }

    useEffect(() => {
        const exit = localStorage.getItem('@exit');
        const userinfo = localStorage.getItem('@userinfo');
        
        if (exit === 'false' || userinfo) {
            localStorage.clear();
            window.location.reload();
        }
    }, []);

    return (
        <S.Container>
            <S.Wrapper>
                <S.ContainerDescription>
                    <S.Description>
                        <img src={LogoBranca} alt='Logo AgroReceita Branco' />

                        <H3 color={theme.colors.white.Branco}>Crie sua nova senha</H3>

                        <BodyG color={theme.colors.gray.Cinza_9}>Você pode mudar sua senha a qualquer momento.</BodyG>

                        <img src={SegurityPassword} alt='Imagem de mulher ao lado de um notebook' />
                    </S.Description>
                </S.ContainerDescription>

            {isValidTicket ? (
                <S.ContainerForm>
                    {loading ? (
                        <S.LoadingContainer disabled={isButtonDisabled} />
                    ) : (
                        <S.Form>
                            <InputV3
                                type='password'
                                floatingLabelWithAsterisk="Senha"
                                placeholder="Senha"
                                value={password}
                                onChange={(e) => {
                                    setPassword(e.target.value);
                                    setErroSenha(false);
                                    setErroSenhaMsg('');
                                }}
                                onKeyDown={(e) => pressKey(e)}
                                isDisabled={false}
                                errorInfo={validacaoAtivada && erroSenha ? erroSenhaMsg : ''}
                                hasError={validacaoAtivada && erroSenha}
                            />

                            <InputV3
                                type='password'
                                floatingLabelWithAsterisk="Confirme a senha"
                                placeholder="Confirme a senha"
                                value={confirmPassword}
                                onChange={(e) => {
                                    setConfirmPassword(e.target.value);
                                    setErroSenha(false);
                                    setErroSenhaMsg('');
                                }}
                                onKeyDown={(e) => pressKey(e)}
                                isDisabled={false}
                                errorInfo={validacaoAtivada && erroSenha ? erroSenhaMsg : ''}
                                hasError={validacaoAtivada && erroSenha}
                            />

                            <S.FormButton
                                type="submit"
                                disabled={isButtonDisabled}
                                onClick={handleContinuarClick}
                            >
                                {loading ? (
                                    <S.Loading disabled={isButtonDisabled} />
                                ) : (
                                    <>
                                        <TaglineM fontWeight={800}>Criar senha</TaglineM>

                                        <img src={isButtonDisabled ? SetaCinza : SetaBranca} alt='Seta' />
                                    </>
                                )}
                            </S.FormButton>
                        </S.Form>
                    )}
                </S.ContainerForm>
                ):(
                    <S.ContainerForm>
                          {loading ? (
                        <S.LoadingContainer disabled={isButtonDisabled} />
                    ) : (
                        <S.FormInvalid>
                            <H6 color={theme.colors.gray.Cinza_5}>Ticket de segurança inválido!</H6>
                        </S.FormInvalid>
                    )}
                    </S.ContainerForm>
                )}
                
            </S.Wrapper>

            <Modal
                show={showModalRedirect}
                size='sm'
                onHide={false}
            >
                <S.ContainerModalRedirect>
                    <H6 color={theme.colors.gray.Cinza_5}>Nova senha criada!</H6>

                    <BodyG color={theme.colors.gray.Cinza_5}>Você já pode entrar no sistema utilizando sua nova senha.</BodyG>

                    <Button
                        width='200px'
                        height='48px'
                        value='Entrar no sistema'
                        outline={false}
                        disabled={false}
                        onClick={() => {
                            window.location.href = '/abrir-app'
                        }}
                        loading={false}
                        id="login"
                    />

                    {/* <a href="/login">
                        <TaglineM color={theme.colors.white.Branco} fontWeight={800}>Entrar no sistema</TaglineM>
                    </a> */}
                </S.ContainerModalRedirect>
            </Modal>
        </S.Container>
    );
};

export default withRouter(Novasenha);
